/* 關張傳・第 1 章：江州（214 年）
 * 南邊長江、北邊嘉陵江，江州城在兩江之間，東西各一座城門。張飛溯江而上，在東邊的江岸登陸；西門外的大路通往成都，路上有兩處劉璋的營壘。 */
export const CITY = { x: 3800, y: 2400, hw: 700, hh: 480 };
const T = 36, G = 130, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const EGATE = [E, CITY.y], WGATE = [Wx, CITY.y], LAND = [7000, 3300], FORTS = [[2100, 2000], [1000, 1650]], EXIT = [300, 1650];
const v = (x: number) => [[x, (N + CITY.y - G) / 2, T, (CITY.y - G - N) / 2], [x, (CITY.y + G + S) / 2, T, (S - CITY.y - G) / 2]];
export default {
  id: 'guanzhang_jiangzhou', name: '江州', W: 8000, H: 4800, seed: 214,
  bases: [LAND, [CITY.x, CITY.y]],
  walls: [[CITY.x, N, CITY.hw + T, T], [CITY.x, S, CITY.hw + T, T], ...v(Wx), ...v(E)],
  rivers: [
    { pts: [[-100, 4300], [2600, 4250], [5400, 4320], [8100, 4260]], hw: 330, fords: [] }, // 長江
    { pts: [[-100, 560], [3000, 520], [6000, 600], [8100, 540]], hw: 200, fords: [] }, // 嘉陵江
  ],
  roads: [{ pts: [LAND, [5600, 2650], EGATE, [CITY.x, CITY.y], WGATE, FORTS[0], FORTS[1], EXIT], w: 140 }],
  rocks: [[6000, 1300, 420, 200], [2400, 3500, 420, 200], [5200, 3700, 380, 180], [1200, 3000, 360, 170]],
  woods: 0.35,
  sight: 0.8,
  clearings: [[CITY.x, CITY.y, 820], [EGATE[0] + 450, EGATE[1], 420], [LAND[0], LAND[1], 500], [WGATE[0] - 300, WGATE[1], 300], ...FORTS.map(([x, y]) => [x, y, 380]), [EXIT[0] + 100, EXIT[1], 200]],
  marsh: [[LAND[0], LAND[1] + 420, 260, 110]],
  tents: [{ x: LAND[0] + 150, y: LAND[1] - 120, n: 4, r: 260, col: '#3e7b50', flag: '張' }, ...FORTS.map(([x, y]) => ({ x, y, n: 5, r: 300, col: '#5d6a78', flag: '璋' }))],
};
